import { Component, AfterViewInit, Input } from '@angular/core';

import { NavbarItem } from '@common/models/navbar-item';
import { ApplicationsService } from '@common/services';
import { ApplicationRole } from '@apps/auth/models';
import { CompareUpperString2 } from '@common/services/utils.service';
import { AppliRoleIcon } from '@apps/auth/domain/models/back/entity';

@Component({
    selector: 'aa-icon-appli',
    templateUrl: './icon-appli.component.html',
    styleUrls: [
        './icon-appli.component.scss'
    ],
    standalone: false
})
export class IconAppliComponent implements AfterViewInit
{
    @Input() appRoles: ApplicationRole[];
    @Input() external: boolean;
    public appliRoleIcons: AppliRoleIcon[];
    public static excludedIds: string[] = ['AUTH', 'DASH', 'ITSM'];

    constructor (
        private applicationsService: ApplicationsService
    )
    {
    }

    ngAfterViewInit (): void
    {
        const publicNavbarItems: NavbarItem[] = this.applicationsService.publicNavbarItems();
        const navbarItems: NavbarItem[] = (this.external ? publicNavbarItems : [...publicNavbarItems, ...this.applicationsService.adminNavbarItems(true)]);

        this.appliRoleIcons = navbarItems
            .filter((ni: NavbarItem): boolean =>
                !IconAppliComponent.excludedIds.includes(ni.id)
            )
            .sort(CompareUpperString2<NavbarItem>((ni: NavbarItem): string =>
                ni.id
            ))
            .map((ni: NavbarItem): AppliRoleIcon =>
            {
                const found: ApplicationRole = this.appRoles
                    .find((appRole: ApplicationRole): boolean =>
                        ni.api === appRole.application
                    );
                const role: string = (found !== undefined ? found.role : 'none').toUpperCase();

                return new AppliRoleIcon(ni.id, role, ni.icon);
            });
    }
}
